import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { ParkingBillingSettingRequest } from '../api/requests/parking-billing-setting-request.ts';
import { createParkingBillingSetting } from '../api/parking-billing-setting.ts';

export default function useCreateParkingBillingSetting(): UseMutationResult<
  string,
  Error,
  ParkingBillingSettingRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ParkingBillingSettingRequest) =>
      createParkingBillingSetting(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parkingBillingSettings'] });
    },
  });
}
